import { useState } from 'react';
import { toast } from 'sonner';
import { useLoader } from './useLoader';
import { submitAccountForValidation, submitOrderForValidation } from '../api/validationService';

export const useValidationSubmit = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const {showLoader, hideLoader} = useLoader();

  const submitValidation = async (orderId, accountId) => {
    if (!orderId || !accountId) {
      toast.error('Données manquantes pour la soumission');
      return false;
    }

    setIsSubmitting(true);
    showLoader({ message: "Soumission de l'ordre en cours...", indeterminate: true });
    try {
      await submitOrderForValidation(orderId, accountId);
      toast.success('Ordre soumis à la validation un email a ete envoyer au validateur pour la validation. veillez patienter... !');
      return true;
    } catch (error) {
      // toast.error(error.message);
      return false;
    } finally {
      setIsSubmitting(false);
        hideLoader();
    }
  };

  return { submitValidation, isSubmitting };
};

export const useAccountValidationSubmit = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { showLoader, hideLoader } = useLoader();

  const submitAccountValidation = async (accountId, submittedByAccountId) => {
    if (!accountId || !submittedByAccountId) {
      toast.error('Données manquantes pour la soumission');
      return false;
    }

    setIsSubmitting(true);
    showLoader({ message: "Soumission du compte en cours...", indeterminate: true });
    
    try {
      await submitAccountForValidation(accountId, submittedByAccountId);
      toast.success('Compte soumis à la validation. Un email a été envoyé au validateur pour la validation. Veuillez patienter...');
      return true;
    } catch (error) {
      toast.error(error.message);
      return false;
    } finally {
      setIsSubmitting(false);
      hideLoader();
    }
  };

  return { submitAccountValidation, isSubmitting };
};